module.exports = __webpack_public_path__ + "static/media/close.c4b9c14e.svg";